import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './pages/home/Home.css'
import './pages/about/About.css'
import './pages/contact/Contact.css'
import './pages/menu/Menu.css'
import './pages/work/raizHambre/RaizHambre.css'
import './pages/work/moltingTime/MoltingTime.css'
import './components/title/Title.css'
import './App.css'
import reportWebVitals from './reportWebVitals';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
